import request from "@/plugins/axiosInstance";

// 获取当前会员信息
export function getMemberInfo(query) {
  return request({
    url: "/v1/member/info",
    method: "get",
    params: query,
  });
}

// 查询积分汇总
export function getMemberPoints() {
  return request({
    url: "/v1/member/points",
    method: "get",
  });
}

// 查询积分流水（分页）
export function getMemberFlows(query) {
  return request({
    url: "/v1/member/flows",
    method: "get",
    params: query,
  });
}

// 查询会员等级权益列表
export function getMemberLevels() {
  return request({
    url: "/v1/member/levels",
    method: "get",
  });
}

// 查询当前会员等级信息（含升级进度）
export function getCurrentMemberLevel() {
  return request({
    url: "/v1/member/levels/current",
    method: "get",
  });
}

// 查询可兑换折扣码列表
export function getAvailableCoupons() {
  return request({
    url: "/v1/member/coupons/available",
    method: "get",
  });
}

// 积分兑换折扣码
export function redeemCoupon(params) {
  return request({
    url: "/v1/member/coupons/redeem",
    method: "post",
    data: params,
  });
}

// 查询我的兑换记录（分页）
export function getMyCoupons(query) {
  return request({
    url: "/v1/member/coupons/my-list",
    method: "get",
    params: query,
  });
}

// 提交关注审核
export function submitFollowAudit(params) {
  return request({
    url: "/v1/member/follow-audits/submit",
    method: "post",
    data: params,
  });
}

// 查询积分任务（奖励规则）
export function getMemberRewards(query) {
  return request({
    url: "/v1/member/rewards",
    method: "get",
    params: query,
  });
}
// 查询我的关注审核记录
export function getMyFollowAudits(query) {
  return request({
    url: "/v1/member/follow-audits/my-list",
    method: "get",
    params: query,
  });
}